import { TRAVEL_ABOUT_STEP } from "Components/Features/CheckPrice/Products/RiskProducts/Travel";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { mapFormToInjuries } from "Store/priceCalculation/productMappers/common/injuriesMapper";

export type TravelProductBackend = {
  name: INSURANCE_NAME_VALUE;
  coverageGroup: any;
  damageCountRecentYears: number;
  yearOfLastDamage?: number;
};

export function mapToCommerceTravel(data: {
  [key: string]: any;
}): TravelProductBackend {
  const formValues = data.formData;
  const damageRecentYears = formValues[TRAVEL_ABOUT_STEP.id].injuries;
  const damageYear = formValues[TRAVEL_ABOUT_STEP.id].injuryYear;

  return {
    name: INSURANCE_NAME_VALUE.TRAVEL,
    coverageGroup: data.coverage,
    ...mapFormToInjuries(damageRecentYears, damageYear),
  };
}
